module.exports = __webpack_public_path__ + "img/logo-black.24aa3683.png";